const initState = {
    court: {
        data: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    },

    location: {
        data: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    },
};

export default initState;